import { MfaType } from './../models/authentication/authLogin.model';

import { StringHelper } from 'app/utility/stringhelper';
import { DialogResult, UserRole } from 'app/utility/enums';
import { throwError as observableThrowError, BehaviorSubject, Observable, of, throwError, Subject, firstValueFrom } from 'rxjs';
import { catchError, tap, timeout, map } from 'rxjs/operators';
import { parsePhoneNumberFromString } from 'libphonenumber-js';
import { NativeService } from './native.service';
import { UserModel } from 'app/models/authentication/user.model';
import { MenuAreaType, MenuService } from './menu.service';
import { AppVersionModel } from 'app/models/shared/appVersion.model';
import { AlertController, ToastController, Platform, LoadingController, NavController, ModalController } from '@ionic/angular';
import { CacheService } from './cache.service';
import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { AuthLoginModel } from 'app/models/authentication/authLogin.model';
import { Constants } from 'app/utility/constants';
import { FeatureFlag, SecurityRight } from 'app/utility/enums';
import { VERSION } from "app/version";

import { AuthChallengeResultModel } from 'app/models/authentication/authChallengeResult.model';
import { AuthChallengeModel } from 'app/models/authentication/authChallenge.model';
import { AuthRefreshTokenResultModel } from 'app/models/authentication/authRefreshTokenResult.model';
import { AuthTokenModel } from 'app/models/authentication/authToken.model';
import { environment } from 'environments/environment';
import { DeviceModel } from 'app/models/shared/device.model';
import { AccountModel } from 'app/models/authentication/account.model';
import { StorageService } from 'app/services/storage.service';


import { Browser } from '@capacitor/browser';
import { Device } from '@capacitor/device';
import { MfaSetupModel } from 'app/models/shared/mfaSetup.model';
import { BooleanResultModel } from 'app/models/shared/booleanResult.model';
import { LabelValueModel } from 'app/models/shared/labelValue.model';
import { WebViewMessageCommandModel } from 'app/models/shared/webViewMessageCommand.model';
import { LicenceModel } from 'app/models/dms/licenceModel';
import { AuthDetailsChangeModel } from 'app/models/authentication/authDetailsChange.model';
import { PasswordResetModel } from 'app/models/shared/passwordReset.model';
import { ProfileService } from './profile.service';

@Injectable({
    providedIn: 'root'
})
export class UserService
{
    loggedInSubject: BehaviorSubject<boolean> = new BehaviorSubject(false);

    constructor(private httpClient: HttpClient,
        private cache: CacheService,
        private alertController: AlertController,
        private toastController: ToastController,
        private platform: Platform,
        private loadingController: LoadingController,
        private menuService: MenuService,
        private navController: NavController,
        private storage: StorageService,
        public nativeService: NativeService,
        private profileService: ProfileService
    )
    {
    }

    version = VERSION.version;

    currentUser: UserModel = null;

    public apiError: boolean = false;

    private _clientSideAuthExpiry: number;
    public get clientSideAuthExpiry(): number
    {
        if (!this._clientSideAuthExpiry)
        {
            this._clientSideAuthExpiry = parseInt(localStorage.getItem(Constants.LocalStorage_ClientsideAuthExpiry)) || 0;
        }
        return this._clientSideAuthExpiry;
    }
    public set clientSideAuthExpiry(expiry: number)
    {
        this._clientSideAuthExpiry = expiry;
        localStorage.setItem(Constants.LocalStorage_ClientsideAuthExpiry, expiry + "");
        // console.debug(`%cset LocalStorage_ClientsideAuthExpiry to ${expiry}`, 'color: orange');
    }

    checkClientSideAuthOk(): boolean
    {
        // console.log("isClientsideExpired called...");

        var isClientsideExpired = this.isClientsideAuthExpired();
        if (isClientsideExpired)
        {
            console.warn("isClientsideExpired is expired");
            this.GetBiometricSetting().then((val) =>
            {
                // console.log(val);
                if (val)
                {
                    console.warn(`isClientsideExpired ${isClientsideExpired}`);
                    this.navController.navigateRoot('/authenticate');
                    return false;
                }
            });
        }

        if (!this.authExpirySettingPending)
        {
            this.authExpirySettingPending = true;
            setTimeout(async () =>
            {
                this.setClientsideAuthExpiry();
                this.authExpirySettingPending = false;
            }, 5000);
        }

        return true;
    }
    authExpirySettingPending: boolean = false;

    isClientsideAuthExpired(): boolean
    {
        var clientsideAuthExpired = false;
        var self = this;
        if ((this.isNative || environment.forceBiometricForTesting) &&
            this.clientSideAuthExpiry)
        {
            clientsideAuthExpired = (this.clientSideAuthExpiry < Date.now());
        }
        else if (this.isNative)
        {
            //check to make sure that it's not been removed
            this.GetBiometricSetting().then((val) =>
            {
                if (!val)
                {
                    console.error("clientSideAuthExpiry setting does not exist! Setting now.");
                    self.setClientsideAuthExpiry();
                }
            });
        }
        return clientsideAuthExpired;
    }

    setClientsideAuthExpiry()
    {
        var nowtime = Date.now();
        this.clientSideAuthExpiry = nowtime + (environment.biometricExpiryMinutes * 60000);
        //console.log("clientSideAuthExpiry set to ", this.clientSideAuthExpiry);
    }

    setClientsideAuthExpiryTo1()
    {
        this.clientSideAuthExpiry = 1;
        this.authExpirySettingPending = true;
        console.debug(`clientsideAuthExpiry set to 1`);
    }
    unsetClientsideAuthExpiry()
    {
        this.clientSideAuthExpiry = 0;
        console.debug(`clientsideAuthExpiry set to 0`);
    }

    public _clientAuthRoute: string;
    public set clientAuthRoute(route: string)
    {
        // console.debug(`setClientAuthRoute ${route}`);
        this._clientAuthRoute = route;
    }
    public get clientAuthRoute(): string
    {
        return this._clientAuthRoute;
    }


    async initCurrentUser(reset: boolean = false): Promise<UserModel>
    {
        if (this.currentUser && !reset) return this.currentUser;
        const currentUser = await this.getCurrentUser(reset).toPromise();
        this.currentUser = currentUser;
        return currentUser;
    }

    public getCurrentUser(bypassCache: boolean = false): Observable<UserModel>
    {
        if (this.currentUser && !bypassCache)
        {
            return of(this.currentUser);
        }

        let cacheKey: string = 'currentUser';
        let cacheMilliseconds: number = 5 * 60000; //5 minutes

        if (bypassCache)
        {
            this.cache.clear(cacheKey);
            this.currentUser = null;
            //console.log('clearing key', cacheKey)
        }
        return this.cache.get(cacheKey, this.getCachelessCurrentUser(), cacheMilliseconds);
    }

    public getCachelessCurrentUser(): Observable<UserModel>
    {
        this.checkAppVersion();
        if (this.currentUser)
        {
            return of(this.currentUser);
        }
        else
        {
            return this.httpClient.get<UserModel>(Constants.ApiUrl + 'Authentication/CurrentUser').pipe(
                map(
                    user =>
                    {
                        this.currentUser = user;
                        localStorage.setItem(Constants.LocalStorage_MCUserId, user.ownerId); //for cache keys
                        localStorage.setItem("motorcentral-dealership-id", user.ownerCompanyId);

                        this.getCachedRights().subscribe({
                            next: x =>
                            {
                                if (x)
                                {
                                    // console.log("setting rights for cacheless current user", x);
                                    this.currentUser.securityRights = x;
                                }
                            }, error: err =>
                            {
                                console.error("getCachedRights error", err);
                            }
                        });
                        localStorage.setItem(Constants.LocalStorage_LoggedIn, "1");
                        this.loggedInSubject.next(true);
                        return this.currentUser;
                    }
                ),
                catchError(err =>
                {
                    this.handleError(err);
                    // Handle the error here. You could, for example, return an Observable with a default value.
                    return of(null);
                }
                ))
        }
    }

    userAndRights(): Observable<UserModel>
    {
        if (this.rights)
        {
            this.currentUser.securityRights = this.rights;
            return of(this.currentUser);
        }
        else
        {
        }
    }

    // Create and store a new PKCE code_verifier (the plaintext random secret)
    private async performAuthChallenge(loginInfo: AuthLoginModel)
    {
        var code_verifier = this.generateRandomString();

        // console.log(code_verifier);

        // Hash and base64-urlencode the secret to use as the challenge
        var code_challenge = await this.pkceChallengeFromVerifier(code_verifier);

        var authChallenge = new AuthChallengeModel();

        var overrideClientID = localStorage.getItem(Constants.LocalStorage_OverrideClientID);
        if (overrideClientID && overrideClientID != '')
        {
            console.warn("override client id: ", overrideClientID);
            authChallenge.clientId = overrideClientID;
        }
        else
        {
            authChallenge.clientId = loginInfo.clientId;
        }
        authChallenge.codeChallenge = code_challenge;
        authChallenge.codeChallengeMethod = "S256";

        // Create authorization request
        var AuthChallengeResultModel = await this.httpClient
            .post<AuthChallengeResultModel>(Constants.ApiUrl + 'authentication/authorize', authChallenge)
            .pipe(timeout(Constants.ApiShortTimeout))
            .toPromise();

        loginInfo.authenticationCode = AuthChallengeResultModel.authenticationCode;
        loginInfo.codeVerifier = code_verifier;
    }

    async loginv3(loginInfo: AuthLoginModel)
    {
        this.setRefreshToken(null);
        this.setAccessToken(null);

        this.currentUser = null;

        await this.performAuthChallenge(loginInfo);

        //see if native
        if (this.isNative)
        {
            var touchId = await this.GetBiometricSetting();
            if (touchId &&
                (this.isNative || environment.forceBiometricForTesting))
            {
                this.setClientsideAuthExpiry();
            }
            else
            {
                this.unsetClientsideAuthExpiry();
            }
        }
        loginInfo.deviceId = await this.getDeviceUUID();
        loginInfo.appVersion = this.version;

        // Login and generate refresh token
        var refreshTokenResult = await this.httpClient
            .post<AuthRefreshTokenResultModel>(Constants.ApiUrlV2 + 'Authentication/Token', loginInfo)
            .pipe(timeout(Constants.ApiShortTimeout))
            .toPromise();
        localStorage.setItem(Constants.LocalStorage_LoggedIn, "1");
        this.setAuthTokens(refreshTokenResult);

        this.loggedInSubject.next(true);
    }

    //request email otp
    async loginAndRequestEmailOtp(loginInfo: AuthLoginModel)
    {
        this.setRefreshToken(null);
        this.setAccessToken(null);

        this.currentUser = null;

        await this.performAuthChallenge(loginInfo);

        //see if native
        if (this.isNative)
        {
            var touchId = await this.GetBiometricSetting();
            if (touchId &&
                (this.isNative || environment.forceBiometricForTesting))
            {
                this.setClientsideAuthExpiry();
            }
            else
            {
                this.unsetClientsideAuthExpiry();
            }
        }
        loginInfo.deviceId = await this.getDeviceUUID();
        loginInfo.appVersion = this.version;

        await this.httpClient.post<any>(Constants.ApiUrlV2 + 'Authentication/Token', loginInfo)
            .pipe(timeout(Constants.ApiShortTimeout))
            .toPromise();

        //we just want a 2xx response
    }

    nonCryptRandomString(): string
    {
        return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
    }

    generateRandomString(): string
    {
        var array = new Uint32Array(28);
        window.crypto.getRandomValues(array);
        return Array.from(array, dec => ('0' + dec.toString(16)).substr(-2)).join('');
    }

    // Calculate the SHA256 hash of the input text.
    // Returns a promise that resolves to an ArrayBuffer
    async sha256(plain): Promise<ArrayBuffer>
    {
        const encoder = new TextEncoder();
        const data = encoder.encode(plain);
        return await window.crypto.subtle.digest('SHA-256', data);
    }

    // Base64-urlencodes the input string
    base64urlencode(str: ArrayBuffer): string
    {
        // Convert the ArrayBuffer to string using Uint8 array to conver to what btoa accepts.
        // btoa accepts chars only within ascii 0-255 and base64 encodes them.
        // Then convert the base64 encoded to base64url encoded
        ////   (replace + with -, replace / with _, trim trailing =)
        return btoa(String.fromCharCode.apply(null, new Uint8Array(str)))
            ;//.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
    };

    // Return the base64-urlencoded sha256 hash for the PKCE challenge
    async pkceChallengeFromVerifier(v): Promise<string>
    {
        var hashed = await this.sha256(v);
        return this.base64urlencode(hashed);
    }

    setAuthTokens(refreshTokenResult: AuthRefreshTokenResultModel)
    {
        if (refreshTokenResult.isAuthenticated)
        {
            // console.debug("set auth tokens");
            // Set the refresh token (versions older than v3.2.3 will not have a refresh token)
            if (refreshTokenResult.refreshToken != '')
            {
                var refreshToken = new AuthTokenModel();
                refreshToken.token = refreshTokenResult.refreshToken;
                refreshToken.tokenExpirationUtc = refreshTokenResult.refreshTokenExpirationUtc;
                this.setRefreshToken(refreshToken);
            }

            var accessToken = new AuthTokenModel();
            accessToken.token = refreshTokenResult.accessToken;
            accessToken.tokenExpirationUtc = refreshTokenResult.tokenExpirationUtc;
            this.setAccessToken(accessToken);
        }
    }

    getNewAccessTokenObservable(): Observable<AuthRefreshTokenResultModel>
    {
        var refreshToken = this.getRefreshToken();
        var accessToken = this.getAccessToken();
        if (refreshToken == null || accessToken == null)
        {
            this.logout();
            if (document.location.href.indexOf('/login') == -1)
            {
                // Redirect to the login page if not currently on it
                this.navController.navigateRoot('/login');
            }
        }

        let request: Observable<AuthRefreshTokenResultModel>;
        const overrideClientID = localStorage.getItem(Constants.LocalStorage_OverrideClientID);
        const headers = new HttpHeaders({
            client_id: overrideClientID && overrideClientID != '' ? overrideClientID : environment.ClientId,
            client_secret: '',
            refresh_token: refreshToken.token,
            app_version: VERSION.version
        });

        request = this.httpClient.get<AuthRefreshTokenResultModel>(Constants.ApiUrlV2 + 'Authentication/Token', { headers } );
        

        return request.pipe(
            tap(x =>
            {
                this.setAuthTokens(x);
            }),
            catchError((err) =>
            {
                // On 401 error, logout and redirect to login
                if (err instanceof HttpErrorResponse && err.status === 401)
                {
                    this.logout();
                    if (document.location.href.indexOf('/login') == -1)
                    {
                        this.navController.navigateRoot('/login');
                    }
                }
                return throwError(() => err);
            })
        );
    }

    public async logout()
    {
        this.currentUser = null;

        console.warn("Doing logout");

        this.loggedInSubject.next(false);
        this.profileService.clearProfileCache();
        this.clearAuthenticationTokens();
        console.warn("resetting cached rights");
        this.resetCachedRights();

        this.menuService.setArea("dms");
    }

    public clearAuthenticationTokens()
    {
        this.unsetClientsideAuthExpiry();

        localStorage.setItem(Constants.LocalStorage_LoggedIn, "0");
        localStorage.removeItem(Constants.LocalStorage_AccessToken);
        localStorage.removeItem(Constants.LocalStorage_RefreshToken);
        this.loggedInSubject.next(false);
    }

    deRegisterDeviceToken(token: string): Observable<string>
    {
        let httpParams = new HttpParams();
        httpParams = httpParams.append('deviceToken', token);
        return this.httpClient.delete<string>(Constants.ApiUrl + 'Notifications/DeviceTokens', { params: httpParams });
    }

    getCurrentDeviceToken(): string
    {
        return localStorage.getItem(Constants.LocalStorage_MCNotificationDeviceToken);
    }

    setCurrentDeviceToken(token: string)
    {
        localStorage.setItem(Constants.LocalStorage_MCNotificationDeviceToken, token);
    }

    removeCurrentDeviceToken()
    {
        localStorage.removeItem(Constants.LocalStorage_MCNotificationDeviceToken);
    }


    setAccessToken(token): void
    {
        if (token != null)
        {
            localStorage.setItem(Constants.LocalStorage_AccessToken, JSON.stringify(token));
        } else
        {
            localStorage.setItem(Constants.LocalStorage_AccessToken, "");
        }
    }

    getAccessToken(): AuthTokenModel
    {
        var token = localStorage.getItem(Constants.LocalStorage_AccessToken);
        return this.buildTokenFromStorage(token);
    }

    setRefreshToken(token): void
    {
        if (token != null)
        {
            localStorage.setItem(Constants.LocalStorage_RefreshToken, JSON.stringify(token));
        } else
        {
            localStorage.setItem(Constants.LocalStorage_RefreshToken, "");
        }
    }

    notifyEmbeddedHostAboutLogin()
    {
        var overrideClientID = localStorage.getItem(Constants.LocalStorage_OverrideClientID);
        if (overrideClientID && overrideClientID != '')
        {
            this.sendChromeMessage("refresh", "token is empty");
            localStorage.setItem(Constants.LocalStorage_LoggedIn, "0");
        }
    }

    sendChromeMessage(action, data)
    {
        console.warn("Send chrome message", action, data);
        var msgObject = {
            action: action,
            data: data
        };
        var json = JSON.stringify(msgObject);
        try
        {
            (window as any).chrome.webview.postMessage(json);
        }
        catch
        {
            //we're not in a webview
        }
    }

    sendChromeMessageClose(dialogResult: DialogResult)
    {
        console.warn("Send chrome message", "close-modal", dialogResult);
        var msgObject = {
            action: "close-modal",
            dialogResult: dialogResult
        };
        var json = JSON.stringify(msgObject);
        try
        {
            (window as any).chrome.webview.postMessage(json);
        }
        catch
        {
            //we're not in a webview
        }
    }

    sendChromeMessageCommand(commandData: WebViewMessageCommandModel)
    {
        console.warn("Send chrome message", "command", commandData);
        var msgObject = {
            action: "command",
            commandData: commandData
        };
        var json = JSON.stringify(msgObject);
        try
        {
            (window as any).chrome.webview.postMessage(json);
        }
        catch
        {
            //we're not in a webview
        }
    }


    getRefreshToken(): AuthTokenModel
    {
        var token = localStorage.getItem(Constants.LocalStorage_RefreshToken);
        return this.buildTokenFromStorage(token);
    }

    buildTokenFromStorage(token: string): AuthTokenModel
    {
        if (token != '' && token != null)
        {
            let tokenParsed = JSON.parse(token) as AuthTokenModel;
            return tokenParsed;
        }
        return null;
    }


    rights: SecurityRight[];
    getRights(): Observable<SecurityRight[]>
    {
        return this.httpClient.get<SecurityRight[]>(Constants.ApiUrl + 'Authentication/Rights');
    }

    setRights()
    {
        if (this.rights)
        {
            return;
        }

        this.getCachedRights();
    }

    getCachedRights(reset: boolean = false): Observable<SecurityRight[]>
    {
        // console.log("getCachedRights", this.rights);
        if (this.rights && !reset) return of(this.rights);

        let cacheMilliseconds: number = 1 * 60 * 60000 * 3; //3 hours
        if (reset) this.resetCachedRights();
        return this.cache.get(this.rightsCacheKey, this.getRights(), cacheMilliseconds).pipe(
            tap(rights =>
            {
                this.rights = rights;
            })
        );
    }

    private get rightsCacheKey(): string
    {
        return Constants.CacheKey_Rights;
    }

    public resetCachedRights()
    {
        this.cache.clear(this.rightsCacheKey);
        this.cache.clear(this.extendedRightsCacheKey);
        this.rights = null;
    }


    async hasUserRightAsync(rightToCheck: SecurityRight): Promise<boolean>
    {
        return this.hasUserRightsAsync([rightToCheck]);
    }

    hasUserRight(rightToCheck: SecurityRight): boolean
    {
        this.setRights();

        if (!this.rights)
        {
            console.error("hasAnyRight: userRights are not populated");
            return false;
        }

        let check = this.rights.filter(x => x == rightToCheck);
        return check.length > 0;
    }

    async initRights(reset: boolean = false): Promise<SecurityRight[]>
    {
        if (this.rights && !reset) return this.rights;
        const rights = await this.getCachedRights().toPromise();
        this.rights = rights;
        return rights;
    }

    async hasUserRightsAsync(rightsToCheck: SecurityRight[]): Promise<boolean>
    {
        if (!this.rights)
        {
            await firstValueFrom(this.getCachedRights());
        }

        var result = this.hasAnyRight(this.rights, rightsToCheck);
        return result;
    }

    hasUserRights(rightsToCheck: SecurityRight[]): boolean
    {
        this.setRights();

        if (!this.rights)
        {
            console.error("hasUserRights: Rights are not populated");
            return false;
        }

        return this.hasAnyRight(this.rights, rightsToCheck);
    }

    hasRight(userRights: SecurityRight[], rightToCheck: SecurityRight): boolean
    {
        // console.log("hasRight", userRights, rightToCheck);
        if (userRights)
        {
            let check = userRights.filter(x => x == rightToCheck);
            // console.log("hasRight", check);
            var hasRight = (check.length > 0);
            // console.log("hasRight", hasRight);
            return hasRight;
        }
        else
        {
            return false;
        }
    }

    hasAnyRight(userRights: SecurityRight[], rightsToCheck: SecurityRight[]): boolean
    {
        if (!rightsToCheck || rightsToCheck.length == 0)
        {
            return true;
        }

        if (!userRights)
        {
            this.setRights();
            userRights = this.rights;
        }

        if (!userRights)
        {
            console.error("hasAnyRight: userRights are not populated");
            return false;
        }

        for (let i = 0; i < rightsToCheck.length; i++)
        {
            let rightToCheck = rightsToCheck[i];
            if (this.hasRight(userRights, rightToCheck))
            {
                return true;
            }
        }

        return false;
    }

    hasAllRights(rightsToCheck: SecurityRight[]): boolean
    {
        if (!rightsToCheck || rightsToCheck.length == 0)
        {
            return true;
        }

        if (rightsToCheck)
        {
            for (let i = 0; i < rightsToCheck.length; i++)
            {
                let rightToCheck = rightsToCheck[i];

                if (!this.hasRight(this.rights, rightToCheck))
                {
                    return false;
                }
            }

            return true;
        }
        else
        {
            return false;
        }
    }

    private featureFlags: FeatureFlag[]
    getFeatures(): Observable<FeatureFlag[]>
    {
        return this.httpClient.get<FeatureFlag[]>(Constants.ApiUrl + 'Authentication/Features');
    }
    getCachedFeatures(reset: boolean = false): Observable<FeatureFlag[]>
    {
        if (this.featureFlags && this.featureFlags.length > 0)
        {
            //console.log(`%cfeatureFlags:`, 'color:gold', this.featureFlags);
            return of(this.featureFlags);
        }
        let cacheMilliseconds: number = 1 * 60 * 60000 * 3; //3 hours
        if (reset)
        {
            //console.log('Reset cached features', this.featuresCacheKey)
            this.cache.clear(this.featuresCacheKey);
        }
        return this.cache.get(this.featuresCacheKey, this.getFeatures(), cacheMilliseconds);
    }
    async initialiseFeatures()
    {
        this.featureFlags = [];
        if (this.mcMinVersion("3.2.3"))
        {
            //console.log(`%cinitialiseFeatures`, 'color:gold');
            this.getCachedFeatures().subscribe({
                next: x =>
                {
                    if (x != null)
                    {
                        this.featureFlags = x;
                        //console.log(`%cfeatureFlags result:`, 'color:gold', x);
                    }
                }, error: err =>
                {
                    console.error("initialiseFeatures error!", err);
                }
            }
            );
        }
    }
    private get featuresCacheKey(): string
    {
        return 'features';
    }
    public hasFeature(feature: FeatureFlag): boolean
    {
        if (this.featureFlags)
        {
            let check = this.featureFlags.filter(x => x == feature);
            // console.debug("hasFeature: ", check);
            return check.length > 0;
        }
        else
        {
            console.debug("hasFeature: features are not populated");
            return false;
        }
    }

    getCurrentApiVersion(): Observable<string>
    {

        return this.httpClient.get<string>(Constants.ApiUrl + 'authentication/version').pipe(
            map(version =>
            {
                return version;
            }));
    }

    loginToPortal(loginInfo: AuthLoginModel)
    {
        // let httpParams = new HttpParams();
        //     httpParams = httpParams.append("ctl00$ctl00$MainContent$MainContent$txtMcAccountCode", loginInfo.customerNumber);
        //     httpParams = httpParams.append("ctl00$ctl00$MainContent$MainContent$txtMcUserName", loginInfo.username);
        //     httpParams = httpParams.append("ctl00$ctl00$MainContent$MainContent$txtMcPassword", loginInfo.password);
        //     httpParams = httpParams.append("ctl00$ctl00$MainContent$MainContent$chkMcRememberMe", "on");


        //     httpParams = httpParams.append("__VIEWSTATE", "i5k2IoNCJfhyQA/ISQW13XJQOFBncHgbWZlTT3OhykCbQaHxYSYAXUbApwiw7LR3kidvCpXhfwCU619Rvj5EBSsaLsJeAjU4hVvpTy8Vs8d/90s3/598kXfYIxT9bvLYQZ1oSDm9jg6KskUNtM8v+TalCtGQoo6Ia81G8n9iJd/gj13FrHNoNDscH8Clzeiw9+l5Q+Zwaejv3zt0WC67s4vNSZl/3AcQzZubyrwgXvMP9E+ydjf8iOmK761Ut9mjOow6sQ8jEkrxl4iocYI8K/v/xtKvoVVggiBJKSci/oZgQQYrHhlrW7fxuK1tfYmdVF94Q9c5CZymAe7TSkYsdda1SvdyigA1vNOYqPnkWI/qUO3m2N2EdcToFg6c6xGwbCNnbmDdwLxvrEPYMGEQR3PPqIAiPDxb+pVlqScwuIeKt2Puff2Er4xHQCFf8Wl8byLKi2anYUwP3mCrKkDvkklt/ZEjuOB22GB/XztQckh47Wn5GL7Vcva36tYTUjr3JulTwW0NiTWKKtGX3926gVG2766SFTc2HgrgqoxbkDV/aOJYpRIh6eQUjmJokKRcvbQr07cVKEyvMYaLyn+RCkym7aGEaIipVaP8IewSFgbjhoBPeGGLbDGuUAZDOtUB50FpGdCadFeHttxXK55GdM+NdqgfSZGXGNmWtW6mSKdCQPTQkK39uU+NExJPQLU4");
        //     httpParams = httpParams.append("__VIEWSTATEGENERATOR", "4BD1CE6E");
        //     httpParams = httpParams.append("__EVENTVALIDATION", "t09lfS8Zy9bYEZY6OTt56JXQKQKEF5ju5umJJ/Nk3e9bVe1bp0hnwF1Yqr14zzU2JXtKbpia2teC5devCgWAM6Juio9QVjlhMW07LPZeDTEcUiejBXdCbXz2Hnq+y5PCD5eYmK1XlhJQYcgUoW63ARgkNYTxnvV7CxJnhaL38+EjYnfwZ8F/xeJlUCEyXsEnp/ojgZVZiYAA0fJj1gdctAhUrRi6HZjxCvnM+v2dqhVl8/LciDOnGc6c7kR9huLcLavk+RbtAz21oDctYDe2bXiWtLhtgVcr3YsHR7vFe/SHI/UPYJtK2VZa2yu9id6f");

        //    return this.httpClient.post<string>('https://portal.motorcentral.co.nz/login', '', { params: httpParams });
    }


    ping(presentAlert: boolean = false): void
    {
        setTimeout(
            () =>
            {
                // console.log(`%cPinging Motorcentral API`, `color: hotpink`)
                this.httpClient.get<string>(Constants.ApiUrl + 'authentication/Ping').pipe(
                    timeout(Constants.ApiShortTimeout),
                    catchError((e: any) => observableThrowError(this.pingErrorHandler(e, presentAlert))))
                    .subscribe({
                        next: x =>
                        {
                            if (x != "1")
                            {
                                this.apiError = true;
                                if (presentAlert)
                                {

                                }
                                else
                                {
                                    this.presentToast("There was an error connecting to Motorcentral. If this error continues, please contact our support team.", 'warning');
                                }
                            }
                        },
                        error: err =>
                        {
                            this.pingErrorHandler(err, true);
                        }
                    });

            }, 2000
        );
    }


    pingErrorHandler(error: any, presentAlert: boolean = false): void
    {
        this.apiError = true;
        console.error(error);

        var title: string;
        var message: string;
        var color: string;
        var timeout = 60000;

        if (!navigator.onLine)
        {
            title = "No Internet Connection";
            message = "Your device appears to be offline.<br/><br/>This app needs an internet connection in order to connect to Motorcentral. Please try reconnecting to wifi."
            color = 'danger';

        }
        else if (error && error.name && error.name == "TimeoutError")
        {
            title = "Motorcentral Error";
            message = "There is a problem connecting to Motorcentral.<br/><br/>If this error continues, please contact our support team.";
            color = 'warning';
        }
        else
        {
            title = "Server Error";
            message = 'There is a problem connecting to Motorcentral at present.<br/><br/>If this error continues, please contact our support team.';
            color = 'danger';
        }
        if (presentAlert)
        {
            this.presentAlert(title, message, false, true, null, timeout);
        }
        else
        {
            this.presentToast(message, color);
        }

    }

    authenticatedPing(): Observable<number>
    {
        return this.httpClient.get<number>(Constants.ApiUrl + 'authentication/AuthenticatedPing');
    }

    setCurrentMcVersion()
    {
        this.currentMCVersion = localStorage.getItem(Constants.LocalStorage_MCDesktopVersion);
    }

    currentMCVersion: string;
    mcMinVersion(version: string): boolean
    {
        if (!this.currentMCVersion)
        {
            this.currentMCVersion = localStorage.getItem(Constants.LocalStorage_MCDesktopVersion);
        }

        var versionCompare = this.version_compare(this.currentMCVersion, version, '>=');
        return versionCompare;
    }

    requireMinVersion(version: string): boolean
    {
        if (!this.mcMinVersion(version))
        {
            this.presentAlert("Please Upgrade", `Your Motorcentral desktop installation needs to be running at least version ${version} in order to perform this action`);
            return false;
        }
        return true;
    }

    version_compare(v1, v2, operator): any
    {
        return StringHelper.versionCompare(v1, v2, operator);
    }

    getCurrentAppVersion(): Observable<AppVersionModel>
    {
        return this.httpClient.get<AppVersionModel>(Constants.ApiUrl + 'authentication/AppVersion').pipe(
            map(version =>
            {
                // console.log("Current app version", version);
                return version;
            }));
    }

    async checkAppVersion()
    {

        var checkForUpdate: boolean = true;
        var updatePrompted = localStorage.getItem(Constants.LocalStorage_UpdatePrompted);
        if (updatePrompted)
        {
            const updatePromptTime = 1000 * 60 * 60 * 6; //6 hours
            var updatePromptedDate = Date.parse(updatePrompted);

            if (Date.now() < (updatePromptedDate + updatePromptTime))
            {
                checkForUpdate = false;
            }
        }

        if (checkForUpdate)
        {

            setTimeout(async () =>
            {
                this.getCurrentAppVersion().subscribe
                    (
                        async version =>
                        {

                            if (this.isNative)
                            {
                                var live_version = this.platform.is('ios') ? version.ios : version.android;

                                if (this.version_compare(live_version, VERSION.version, ">"))
                                {
                                    localStorage.setItem("update_prompted", new Date().toISOString());
                                    const alert = await this.alertController.create({
                                        header: "Update Available",
                                        message: "A new app version is available for download from the app store. Would you like to go there now?",
                                        buttons: [
                                            {
                                                text: 'Cancel',
                                                role: 'cancel',
                                                cssClass: 'secondary',
                                                handler: (blah) =>
                                                {
                                                }
                                            },
                                            {
                                                text: 'Update Now',
                                                handler: async () =>
                                                {
                                                    await Browser.open({ url: "https://motorcentral.app" });
                                                }
                                            }
                                        ]
                                    });
                                    await alert.present();

                                }
                            }
                        }
                    );

            }, 10000);
        }

    }


    hasArea(area: MenuAreaType)
    {
        switch (area)
        {
            case "wholesale":
                return this.hasUserRight(SecurityRight.ToolsDealerzoneWholesale);
                break;
            case "carcheck":
                return this.hasUserRight(SecurityRight.ToolsDealerzone);
                break;
            default:
                return true;
        }
    }

    async getDeviceUUID(): Promise<string>
    {
        const info = await Device.getId();
        // console.log(info);
        return info.identifier;
    }

    public sendDeviceInfo(deviceDetails: DeviceModel): Observable<string>
    {
        //console.log(Constants.ApiUrl + 'authentication/support');
        return this.httpClient.post<string>(Constants.ApiUrl + 'authentication/support', deviceDetails).pipe(
            map(result =>
            {
                return result;
            }));
    }


    public async confirmLogout()
    {
        //prompt user to save
        const alert = await this.alertController.create({
            header: "Confirm sign out",
            message: "Are you sure you wish to sign out?",
            buttons: [
                {
                    text: 'Cancel',
                    role: 'cancel',
                    cssClass: 'primary',
                    handler: () =>
                    {
                        return;
                    }
                },
                {
                    text: 'OK',
                    cssClass: 'danger',
                    handler: () =>
                    {
                        this.doLogout();
                    }
                }
            ]
        });
        await alert.present();

    }

    public async doLogout()
    {
        this.currentMCVersion = null;

        var currentDeviceToken = this.getCurrentDeviceToken();

        if (currentDeviceToken)
        {
            console.debug("Unsubscribing from notifications for device token", currentDeviceToken);
            // Show a loading spinner while preparing to log out
            const loading = await this.loadingController.create({
                message: 'Logging out...',
                duration: 15000,
                backdropDismiss: true
            });
            await loading.present();
            //deregister device notifications
            this.deRegisterDeviceToken(currentDeviceToken)
                .pipe(timeout(Constants.ApiShortTimeout))
                .subscribe({
                    next: x =>
                    {
                        this.removeCurrentDeviceToken();
                        this.loadingController.dismiss();
                        this.doLogoutWithSpinner();
                    },
                    error: err =>
                    {
                        this.loadingController.dismiss();
                        this.doLogoutWithSpinner();
                    }
                });
        }
        else
        {
            this.doLogoutWithSpinner();
        }
    }


    private async doLogoutWithSpinner()
    {
        const loading = await this.loadingController.create({
            message: 'Logging out',
            duration: 20000,
            backdropDismiss: true
        });
        await loading.present();
        this.logout();
        this.loadingController.dismiss();
        this.menuService.setArea("dms");
        this.navController.navigateRoot("/splash");
    }

    getUserAccount(): Observable<AccountModel>
    {
        return this.httpClient.get<AccountModel>(Constants.ApiUrl + 'Companies/Account');
    }
    saveUserAccount(account: AccountModel): Observable<AccountModel>
    {
        return this.httpClient.put<AccountModel>(Constants.ApiUrl + 'Companies/Account', account);
    }

    _isNative: boolean = false;
    nativeSet: boolean = false;
    public get isNative(): boolean
    {
        if (!this.nativeSet)
        {
            this._isNative = (this.platform.is('cordova') && (this.platform.is('android') || this.platform.is('ios')));
        }
        return this._isNative;
    }

    private async GetBiometricSettingKey(): Promise<string>
    {
        var customerNumber = await this.storage.get(Constants.IonicStorage_CustomerNumber, false);
        var username = await this.storage.get(Constants.IonicStorage_Username, false);

        return Constants.LocalStorage_BiometricID + "-" + customerNumber + "-" + username
    }

    async GetBiometricSetting(): Promise<boolean>
    {
        var key = await this.GetBiometricSettingKey();
        let val: boolean = await this.storage.get(key, false);
        return val;
    }

    async SetBiometricSetting(setting: boolean)
    {
        var key = await this.GetBiometricSettingKey();
        await this.storage.set(key, setting, false);
    }

    async GetForceBiometricSetting(): Promise<boolean>
    {
        var key = await this.GetBiometricSettingKey() + "-force";
        let val: boolean = await this.storage.get(key, false);
        return val;
    }

    async SetForceBiometricSetting(setting: boolean)
    {
        var key = await this.GetBiometricSettingKey() + "-force";;
        await this.storage.set(key, setting, false);
    }

    async GetBiometricSetupPromptSetting(): Promise<boolean>
    {
        var key = await this.GetBiometricSettingKey() + "-prompt";
        let val: number = await this.storage.get(key, false);

        var promptExpired = (!val || val < Date.now());

        return promptExpired;
    }

    async SetBiometricSetupPromptSetting(numberOfDaysAway: number)
    {
        var promptAgain = new Date();
        promptAgain.setDate(promptAgain.getDate() + numberOfDaysAway);
        var key = await this.GetBiometricSettingKey() + "-prompt";;
        await this.storage.set(key, promptAgain.getTime(), false);
    }

    async PromptToEnableBiometrics(biometricTypeID: string)
    {
        var biometricType = this.BiometricTypeLabel(biometricTypeID);

        var self = this;
        const alert = await this.alertController.create({
            header: "Biometric security",
            message: biometricType + " is available on this device. Would you like to enable it now for this app?",
            buttons: [
                {
                    text: 'Turn on ' + biometricType,
                    handler: () =>
                    {
                        //console.log('Confirm Turn on');
                        this.SetBiometricSetupPromptSetting(1);
                        this.SetBiometricSetting(true);
                        this.SetForceBiometricSetting(true);
                        this.doLogout();
                    }
                },
                {
                    text: 'Remind me later',
                    role: 'cancel',
                    cssClass: 'secondary',
                    handler: () =>
                    {
                        //console.log('Confirm Cancel');
                        self.SetBiometricSetupPromptSetting(7);
                    }
                },
                {
                    text: 'No Thanks',
                    cssClass: 'secondary',
                    handler: () =>
                    {
                        //console.log('Confirm No Thanks');
                        self.SetBiometricSetupPromptSetting(1000);
                    }
                }
            ]
        });
        await alert.present();
    }

    public BiometricTypeLabel(biometricTypeID: any): string
    {
        switch (biometricTypeID)
        {
            case "face":
                return this.platform.is('android') ? "Face Recognition" : "Face ID";
                break;
            case "finger":
                return this.platform.is('android') ? "Fingerprint ID" : "Touch ID";
                break;
            case "biometric":
            default:
                return "Biometric ID";
        }
    }
    public BiometricTypeIcon(biometricTypeID: any): string
    {
        switch (biometricTypeID)
        {
            case "face":
                return "scan-outline";
                break;
            case "finger":
            case "biometric":
            default:
                return "finger-print-outline";
        }
    }

    extendedRights: SecurityRight[];
    async fetchExtendedRights(refetch: boolean = false): Promise<SecurityRight[]>
    {
        //console.log(`%cfetchExtendedRights`, 'color: purple');
        const rights = await this.getCachedExtendedRights(refetch).toPromise();
        this.extendedRights = rights;
        return rights;
    }

    setExtendedRights()
    {
        this.getCachedRights()
            .subscribe(e =>
            {
                if (e)
                {
                    this.extendedRights = e;
                    //console.log(`%cextended rights fetched: ${e}`, 'color: purple');
                }
            });
    }

    getCachedExtendedRights(reset: boolean = false): Observable<SecurityRight[]>
    {
        if (this.extendedRights)
        {
            return of(this.extendedRights);
        }

        let cacheMilliseconds: number = 1 * 60 * 60000 * 3; //3 hours
        if (reset)
        {
            this.cache.clear(this.extendedRightsCacheKey);
        }
        return this.cache.get(this.extendedRightsCacheKey, this.getExtendedRights(), cacheMilliseconds);
    }

    private get extendedRightsCacheKey(): string
    {
        return Constants.CacheKey_RightsExtended;
    }

    getExtendedRights(): Observable<SecurityRight[]>
    {
        return this.httpClient.get<SecurityRight[]>(Constants.ApiUrl + 'Authentication/ExtendedRights')
            .pipe(catchError((e: any) => observableThrowError(this.handleDeepError(e))));
    }

    async hasExtendedRightAsync(rightToCheck: SecurityRight, refetch: boolean = false): Promise<boolean>
    {
        if (!this.extendedRights)
        {
            refetch = true;
        }
        if (refetch)
        {
            const rights = await this.fetchExtendedRights(true);
            this.extendedRights = rights;
        }

        let check = this.extendedRights.filter(x => x == rightToCheck);
        return check.length > 0;
    }

    public handleDeepError(error: any)
    {
        this.handleError(error, false, false, false, true)
    }
    public handleError(error: any, disableShowBack: boolean = false, logOnly: boolean = false, showAlert: boolean = true, showToast: boolean = false)
    {
        console.error("handleError", error);
        if (logOnly || !error)
        {
            return;
        }
        var showBack = false;
        var errorTitle = 'Error';
        var errorMessage = (error.Message) ? error.Message : '';
        var statusCode = "500";
        if (error.StatusCode)
        {
            statusCode = error.StatusCode
        }
        else if (error.status)
        {
            statusCode = error.status;
        }
        if (error.statusText)
        {
            errorMessage = error.statusText;
        }

        var dtoError;
        if (error.error && error.error.entityDataJson)
        {
            dtoError = JSON.parse(error.error.entityDataJson);
            console.error("dtoError", dtoError);
        }

        if (dtoError && dtoError.Message != null)
        {
            //api error
            errorMessage = dtoError.Message;

            switch (dtoError.StatusCode)
            {
                case 404:
                    errorTitle = "Not Found Error";
                    errorMessage = "Resource not found";
                    showBack = true;
                    break;
                case 400:
                    errorTitle = "Validation Error";
                    errorMessage = errorMessage;
                    break;
                case 401:
                    errorTitle = "Login Error"; //we shouldn't get this
                    this.navController.navigateRoot('/login');
                    return;
                    break;
                case 403:
                    errorTitle = "Security Error";
                    showBack = true;
                    break;
                case 500:
                    if (errorMessage == 'Object reference not set to an instance of an object.')
                    {
                        errorMessage = 'Resource not found';
                    }
                    break;
                default:
                    errorTitle = "Error";
                    break;
            }
        }
        else
        {
            switch (parseInt(statusCode))
            {
                case 404:
                    errorTitle = "Not Found Error";
                    errorMessage = "Resource not found";
                    showBack = true;
                    break;
                case 400:
                    errorTitle = "Validation Error";
                    break;
                case 401:
                    errorTitle = "Login Error"; //we shouldn't get this
                    this.navController.navigateRoot('/login');
                    break;
                case 403:
                    errorTitle = "Security Error";
                    showBack = true;
                    break;
                case 500:
                default:
                    errorTitle = "Internal Error";
                    showBack = true;
                    errorTitle = statusCode + " Error";
                    if (error.name == "TimeoutError")
                    {
                        errorTitle = "Timeout Error"
                        if (!errorMessage)
                        {
                            errorMessage = "Unable to load resource in a timely manner. There may be an issue with connecting to Motorcentral.<br/><br/>If this error continues please contact our support team.";
                        }
                    }
                    else if (error.name == "HttpErrorResponse")
                    {
                        errorTitle = "Resource Error"
                        if (!errorMessage)
                        {
                            errorMessage = "Failed to load resource. Please check your internet connection.<br/><br/>If this error continues please contact our support team.";
                        }
                    }
                    break;
            }
        }
        if (showAlert && !this.alertActive)
        {
            this.alertActive = true;
            this.presentAlert(errorTitle, errorMessage, (showBack && !disableShowBack));
        }
        else if (showToast)
        {
            this.presentToast(errorTitle + ": " + errorMessage);
        }

        return errorMessage;

    }

    alertActive: boolean = false;

    async presentAlert(title: string, message: string, back: boolean = false, reload: boolean = false, disableOk: boolean = false, timeout = 300000)
    {
        // console.log('presentAlert', title, message);
        var buttons = [];
        if (!disableOk)
        {
            buttons.push({
                text: 'OK',
                role: 'cancel',
                cssClass: 'secondary',
                handler: () =>
                {
                    this.alertActive = false;
                }
            });
        }
        if (back)
        {
            buttons.push({
                text: 'Go Back',
                role: '',
                cssClass: 'secondary',
                handler: () =>
                {
                    this.alertActive = false;
                    history.go(-1);
                }
            });
        }
        if (reload)
        {
            buttons.push({
                text: 'Reload',
                role: '',
                cssClass: 'secondary',
                handler: () =>
                {
                    this.alertActive = false;
                    location.reload();
                }
            });
        }
        const alert = await this.alertController.create({
            header: title,
            message: message,
            buttons: buttons
        });

        await alert.present();

        setTimeout(() =>
        {
            alert.dismiss();
        }, timeout);
    }

    async presentToast(message: string, color: string = "warning", duration: number = 10000)
    {

        const toast = await this.toastController.create({
            message: message,
            duration,
            position: "bottom",
            animated: true,
            color: color,
            translucent: true,
            buttons: [
                {
                    side: 'end',
                    icon: 'close-circle-outline',
                    role: 'cancel',
                    handler: () =>
                    {
                        toast.dismiss();
                    }
                }
            ]
        });
        toast.present();
    }




    async checkUserAccountDetails()
    {
        this.getUserAccount().subscribe
            (
                y =>
                {
                    if (!this.validEmail(y.email) || !this.validPhone(y.mobile))
                    {
                        this.promptToUpdateAccountDetails();
                    }
                }
            );
    }
    async promptToUpdateAccountDetails()
    {
        const toast = await this.toastController.create({
            // header: 'Missing details',
            message: 'Your contact details need updating',
            position: 'bottom',
            color: 'dark',
            duration: 20000,
            animated: true,
            buttons: [
                {
                    text: 'Update now',
                    handler: () =>
                    {
                        this.navController.navigateRoot("/user?t=contact-details")
                    },
                },
                {
                    side: 'end',
                    icon: 'close-circle-outline',
                    role: 'cancel',
                    handler: () =>
                    {
                        toast.dismiss();
                    }
                }
            ]
        });
        await toast.present();

        const { role } = await toast.onDidDismiss();
    }

    public validEmail(email: string): boolean
    {
        var re = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
        return re.test(String(email).toLowerCase());
    }

    public validPhone(phone: string): boolean
    {
        var phoneNumber = parsePhoneNumberFromString(phone, "NZ");
        if (phoneNumber && phoneNumber.isValid())
        {
            return true;
        }
    }

    public hasStocktakeOnlyRights(): boolean
    {
        return (!this.hasRight(this.rights, SecurityRight.VehiclesTabsGeneralView) && this.hasRight(this.rights, SecurityRight.ToolsVehicleStocktakeTool))
    }

    public hasAnyRole(roles: UserRole[]): boolean
    {
        if (!this.currentUser)
        {
            console.error("Current User is not set");
            return;
        }

        if (!this.currentUser.userRoles)
        {
            console.error("User roles are not set");
            return;
        }

        var filtered = this.currentUser.userRoles.filter(x => roles.includes(<UserRole>x.caption));
        return (filtered.length > 0);
    }


    async resetPassword(loginInfo: AuthLoginModel)
    {
        await this.performAuthChallenge(loginInfo);

        const loading = await this.loadingController.create({
            message: 'Requesting password reset',
            duration: 15000,
            backdropDismiss: true
        });
        await loading.present();

        this.httpClient.post<any>(Constants.ApiUrl + 'authentication/PasswordResetRequest', loginInfo)
            .pipe(timeout(Constants.ApiShortTimeout))
            .subscribe
            ({
                next: async x =>
                {
                    this.loadingController.dismiss();
                    this.presentToast('Password reset has been requested!<br/><br/>Once you have reset your password, come back here to log in.', 'secondary');
                },
                error: err =>
                {
                    this.loadingController.dismiss();
                    this.handleError(err, true, false, true);
                }
            });
    }

    async getDeviceId()
    {
        const deviceId = await this.getDeviceUUID();
        return deviceId;
    }


    revokeMfa(deviceId: string, confirmationOtp: string, mfaType: MfaType): Observable<MfaSetupModel>
    {
        let httpParams = new HttpParams()
            .set('deviceId', deviceId)
            .set('confirmationOtp', confirmationOtp)
            .set('mfaType', mfaType);
        return this.httpClient.post<MfaSetupModel>(Constants.ApiUrl + 'authentication/RevokeMfa', httpParams);
    }

    setupOtp(deviceId: string, confirmationOtp: string, mfaType: MfaType): Observable<MfaSetupModel>
    {
        let httpParams = new HttpParams()
            .set('deviceId', deviceId)
            .set('confirmationOtp', confirmationOtp)
            .set('mfaType', mfaType);
        return this.httpClient.post<MfaSetupModel>(Constants.ApiUrl + 'authentication/SetupMfa', httpParams);
    }

    verifyDeviceOtp(deviceId: string, code: string): Observable<BooleanResultModel>
    {
        let httpParams = new HttpParams()
            .set('deviceId', deviceId)
            .set('code', code);
        return this.httpClient.post<BooleanResultModel>(Constants.ApiUrl + 'authentication/VerifyMfa', httpParams);
    }

    requestEmailOtp(deviceId: string): Observable<LabelValueModel>
    {
        let httpParams = new HttpParams()
            .set('deviceId', deviceId);
        return this.httpClient.post<LabelValueModel>(Constants.ApiUrl + 'authentication/RequestEmailOtp', httpParams);
    }

    requestEmailChangeOtp(deviceId: string, email: string): Observable<LabelValueModel>
    {
        let httpParams = new HttpParams()
            .set('deviceId', deviceId)
            .set('email', email);
        return this.httpClient.post<LabelValueModel>(Constants.ApiUrl + 'authentication/RequestEmailChangeOtp', httpParams);
    }

    verifyMfaCodeAuthenticated(deviceId: string, confirmationOtp: string): Observable<BooleanResultModel>
    {
        let httpParams = new HttpParams()
            .set('deviceId', deviceId)
            .set('rememberDevice', 'false')
            .set('confirmationOtp', confirmationOtp)
            .set('mfaType', 'AuthenticatorOtp');
        return this.httpClient.post<BooleanResultModel>(Constants.ApiUrl + 'authentication/VerifyMfaCodeAuthenticated', httpParams);
    }

    getLicence(): Observable<LicenceModel>
    {
        return this.httpClient.get<LicenceModel>(Constants.ApiUrl + 'authentication/currentLicence');
    }

    getWhitelistedFileExtensions(): Observable<string[]>
    {
        return this.httpClient.get<string[]>(Constants.ApiUrl + 'lookups/whitelistedFileExtensions');
    }

    checkVehicleLimit(): Observable<string>
    {
        return this.httpClient.get<string>(Constants.ApiUrl + 'authentication/checkVehicleLimit');
    }

    saveUserAccountDetailsWithMfa(authDetails: AuthDetailsChangeModel): Observable<any>
    {
        return this.httpClient.put<any>(Constants.ApiUrl + 'Companies/AccountUpdateWithMfa', authDetails);
    }

    verifyPasswordResetCode(resetCode: string): Observable<boolean>
    {
        let httpParams = new HttpParams()
        httpParams = httpParams.append('resetCode', resetCode);
        return this.httpClient.get<boolean>(Constants.ApiUrl + 'authentication/VerifyPasswordResetCode', { params: httpParams });
    }

    performPasswordReset(passwordResetInfo: PasswordResetModel): Observable<PasswordResetModel>
    {
        return this.httpClient.post<PasswordResetModel>(Constants.ApiUrl + 'authentication/PerformPasswordReset', passwordResetInfo);
    }

}
